<template>
  <div>
    <nav class="grey darken-3" role="navigation">
      <div class="nav-wrapper container">
        <a id="logo-container" href="#" class="brand-logo"><img src="static/img/logo.png" alt="logo"></a>
        <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons">menu</i></a>

        <ul class="right hide-on-med-and-down">
          <li>
            <router-link to="/">{{$t('navigation.home')}}</router-link>
          </li>
          <li>
            <router-link to="/experience">Experience</router-link>
          </li>
          <li>
            <router-link to="/cv">CV</router-link>
          </li>
          <li><a class="dropdown-trigger" href="#" data-target="dropdown_side_projects">Side Project<i
            class="material-icons right">arrow_drop_down</i></a></li>
          <li>
            <div class="locale-changer">
              <label>
                <select v-model="$i18n.locale">
                  <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
                </select>
              </label>
            </div>
          </li>
        </ul>

        <ul id="mobile-demo" class="sidenav">
          <li>
            <router-link to="/">{{$t('navigation.home')}}</router-link>
          </li>
          <li>
            <router-link to="/experience">Experience</router-link>
          </li>
          <li>
            <router-link to="/cv">CV</router-link>
          </li>
          <li><a class="dropdown-trigger2" href="#" data-target="dropdown_side_projects2">Side Project<i
            class="material-icons right">arrow_drop_down</i></a></li>
          <li>
            <div class="locale-changer">
              <label>
                <select v-model="$i18n.locale">
                  <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
                </select>
              </label>
            </div>
          </li>
        </ul>

        <ul id="dropdown_side_projects" class="dropdown-content grey darken-3">
          <li>
            <router-link to="/python">Python</router-link>
          </li>
          <li>
            <router-link to="/java">Java</router-link>
          </li>
          <li>
            <router-link to="/android">Android</router-link>
          </li>
          <li>
            <router-link to="/php">PHP</router-link>
          </li>
          <li>
            <router-link to="/nodejs">NodeJs</router-link>
          </li>
          <li>
            <router-link to="/html">HTML</router-link>
          </li>
          <li>
            <router-link to="/csharp">C#</router-link>
          </li>
          <li>
            <router-link to="/ml">Machine Learning</router-link>
          </li>
          <li>
            <router-link to="/devops">DevOps</router-link>
          </li>
          <li>
            <router-link to="/team">{{$t('navigation.team')}}</router-link>
          </li>
        </ul>

        <ul id="dropdown_side_projects2" class="dropdown-content">
          <li>
            <router-link to="/python">Python</router-link>
          </li>
          <li>
            <router-link to="/java">Java</router-link>
          </li>
          <li>
            <router-link to="/android">Android</router-link>
          </li>
          <li>
            <router-link to="/php">PHP</router-link>
          </li>
          <li>
            <router-link to="/nodejs">NodeJs</router-link>
          </li>
          <li>
            <router-link to="/html">HTML</router-link>
          </li>
          <li>
            <router-link to="/csharp">C#</router-link>
          </li>
          <li>
            <router-link to="/ml">Machine Learning</router-link>
          </li>
          <li>
            <router-link to="/devops">DevOps</router-link>
          </li>
          <li>
            <router-link to="/team">{{$t('navigation.team')}}</router-link>
          </li>
        </ul>
      </div>
    </nav>

  </div>
</template>

<script>
  export default {
    name: 'Navigation',
    data () {
      return { langs: ['fr', 'en'] }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue